// extracted by css-extract-rspack-plugin
export default {"stepDots":"src-shared-components-MainLayout-components-FullPageOnboarding-components-StepDots-StepDots-module__stepDots-TPPC2G","stepDot":"src-shared-components-MainLayout-components-FullPageOnboarding-components-StepDots-StepDots-module__stepDot-jdQnh_","stepDotActive":"src-shared-components-MainLayout-components-FullPageOnboarding-components-StepDots-StepDots-module__stepDotActive-zsWNnZ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"stepDots\":\"src-shared-components-MainLayout-components-FullPageOnboarding-components-StepDots-StepDots-module__stepDots-TPPC2G\",\"stepDot\":\"src-shared-components-MainLayout-components-FullPageOnboarding-components-StepDots-StepDots-module__stepDot-jdQnh_\",\"stepDotActive\":\"src-shared-components-MainLayout-components-FullPageOnboarding-components-StepDots-StepDots-module__stepDotActive-zsWNnZ\"}";
        // 1793872695954
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  